import Alert from '@/storybook/components/Alert/Alert';
import Link from '@/storybook/components/Link/Link';
import Text from '@/storybook/components/Text/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ATDataPrivacyDisclaimer.module.css';

const ATDataPrivacyDisclaimer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Alert variant="warning" message={t('header.ATDisclaimer.title')}>
      <Text as="div" className={styles.para}>
        {t('header.ATDisclaimer.paragraph1.part1')}
        <Text as="span" className={styles.textSegment}>
          <Link
            appearance="secondary"
            isExternal
            size="S"
            to={'https://sites.google.com/roche.com/rvi-betriebsrat/startseite/team'}
          >
            {t('header.ATDisclaimer.paragraph1.part2')}
          </Link>
        </Text>
        <Text as="span" className={styles.textSegment}>
          {t('header.ATDisclaimer.paragraph1.part3')}
        </Text>
      </Text>

      <Text as="div" className={styles.para}>
        <Link
          appearance="secondary"
          isExternal
          to="https://roche.service-now.com/people_and_culture?id=kb_article&sysparm_article=KB5043864"
          className={styles.link}
        >
          {t('header.ATDisclaimer.paragraph2')}
        </Link>
      </Text>
    </Alert>
  );
};

export default ATDataPrivacyDisclaimer;
